package com.solevo.dist.theme

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.rgb
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.rgba

/**
 * Created by Ilija Vucetic on 29.9.25..
 * Copyright (c) 2025 Aktiia. All rights reserved.
 */
enum class JsTheme(
    val hex: String,
    val rgb: Color.Rgb
) {
    Primary(
        hex = "#D7EDFF",
        rgb = rgb(r = 215, g = 237, b = 255)
    ),
    Gray600(
        hex = "#808087",
        rgb = rgb(r = 128, g = 128, b = 135)
    ),
    Secondary(
        hex = "#001019",
        rgb = rgb(r = 0, g = 16, b = 25)
    ),
    Tertiary(
        hex = "#001925",
        rgb = rgb(r = 0, g = 25, b = 37)
    ),
    LightGray(
        hex = "#FAFAFA",
        rgb(246, 248, 249)
    ),
    Gray(
        hex = "#E9E9E9",
        rgb = rgb(r = 233, g = 233, b = 233)
    ),
    DarkGray(
        hex = "#252C32",
        rgb(37, 44, 50)
    ),

    VeryDarkGray(
        hex = "#75808A",
        rgb = rgb(117, 128, 138)
    ),

    HalfWhite(
        hex = "#FFFFFF",
        rgb = rgba(r = 255, g = 255, b = 255, a = 0.5f)
    ),
    HalfBlack(
        hex = "#000000",
        rgb = rgba(r = 0, g = 0, b = 0, a = 0.5f)
    ),
    White(
        hex = "#FFFFFF",
        rgb = rgb(r = 255, g = 255, b = 255)
    ),
    Green(
        hex = "#00FF94",
        rgb = rgb(r = 0, g = 255, b = 148)
    ),
    Yellow(
        hex = "#FFEC45",
        rgb = rgb(r = 255, g = 236, b = 69)
    ),
    Red(
        hex = "#FF6359",
        rgb = rgb(r = 255, g = 99, b = 89)
    ),
    StatusRed(
        hex = "#FF0033",
        rgb = rgb(r = 255, g = 0, b = 51)
    ),
    Purple(
        hex = "#8B6DFF",
        rgb = rgb(r = 139, g = 109, b = 255)
    ),
    StatusYellow(
        hex = "#FFBE3D",
        rgb = rgb(r = 255, g = 190, b = 61)
    ),
    Sponsored(
        hex = "#3300FF",
        rgb = rgb(r = 51, g = 0, b = 255)
    ),
    StatusGreen(
        hex = "#01AF57",
        rgb = rgb(r = 1, g = 175, b = 87)
    ),

    BlueDark(
        hex = "#0F67EA",
        rgb = rgb(r = 15, g = 103, b = 234)
    ),

    BlueLight(
        hex = "#D7EDFF",
        rgb = rgb(r = 215, g = 237, b = 255)
    )
}